import React from 'react';
import buttonPropTypes from './ButtonProptypes';

const PrimaryButton = ({
  onClick = () => {},
  children,
  customClass = '',
  disabled = false,
  fullWidth = false,
  ...rest
}) => {
  const disabledClasses = 'opacity-50';

  const classes = `bg-custom-light-blue border-[2px] border-custom-light-blue text-white py-[14px] rounded-[10px] px-[16px] font-medium text-[16px] leading-[18px]
      ${fullWidth ? 'w-full' : 'max-w-max'} 
      ${disabled ? disabledClasses : ''}`;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${classes} ${customClass}`}
      {...rest}
    >
      {children}
    </button>
  );
};

PrimaryButton.propTypes = buttonPropTypes;

export default PrimaryButton;
